var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTm1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 26,
    viewBox: "0 0 64 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16512 18.3525V10.9812H0.166504V5.49171H2.59119C3.85624 5.49171 4.54886 4.61141 4.54886 3.34631V0.078125H11.3822V5.41475H16.2959V10.9812H11.3822V17.9308C11.3822 19.159 12.2657 19.9655 13.7627 19.9655H16.2928V25.8388H11.728C7.00622 25.8388 4.16512 22.9976 4.16512 18.3525Z",
    fill: "#2FE577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1748 5.41475H25.9312V7.33455H26.277C27.0487 6.18225 28.7723 4.91504 31.3446 4.91504C33.8399 4.91504 35.7596 5.7985 36.9878 7.33455H37.2956C38.7156 5.72154 40.5584 4.91504 42.9388 4.91504C47.3538 4.91504 50.3478 7.75625 50.3478 11.9026V25.8388H43.1307V14.475C43.1307 12.863 42.5161 11.6338 40.8272 11.6338C39.2143 11.6338 38.4468 13.0549 38.4468 14.7059V25.8388H31.2297V14.475C31.2297 12.863 30.5381 11.6338 28.8493 11.6338C27.2374 11.6338 26.3919 13.0549 26.3919 14.7059V25.8388H19.1748V5.41475Z",
    fill: "#2FE577"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.9884 0.078125V3.34631C56.9884 4.61141 56.2968 5.49698 55.0297 5.49698H52.605V10.9865H56.6047V25.8324H63.8028V0.078125H56.9884Z",
    fill: "#2FE577"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.6364,
    height: 25.7606,
    fill: "white",
    transform: "translate(0.166504 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTm1);
export default __webpack_public_path__ + "static/media/logoTm1.56095ed5.svg";
export { ForwardRef as ReactComponent };